import { render } from "./AudioSettingsModal.vue?vue&type=template&id=530cada7&scoped=true"
import script from "./AudioSettingsModal.vue?vue&type=script&lang=js"
export * from "./AudioSettingsModal.vue?vue&type=script&lang=js"

import "./AudioSettingsModal.vue?vue&type=style&index=0&id=530cada7&scoped=true&lang=less"
import "./AudioSettingsModal.vue?vue&type=style&index=1&id=530cada7&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530cada7"]])

export default __exports__